export default __webpack_public_path__ + "static/media/hht2_ep03_timeline_05_blank.b0408d8b.png";